export const AuthInterceptorSkipHeader = 'X-Skip-Auth-Interceptor';
export const BaseUrlSkipHeader = 'X-Skip-Base-URL';
